import { Lang } from "../Lang";


/**
 *
 */
export namespace Emote {

	/**
	 *
	 */
	export class GitHub extends Lang {
	}
	Object.freeze(GitHub);
	Object.freeze(GitHub.prototype);
}
Object.freeze(Emote);